export class RegAgenteControlViewModel {
    public IdUsuario: number;

    public Ropo = '';

    public IdProvincia: number;

    public Direccion = '';

    public Localidad = '';

    public CodigoPostal = '';

    public Telefono = '';

    public Observaciones = '';

    public FechaAlta: Date | null;
    public FechaBaja: Date | null;

    public Activo: boolean;

    public TwRegAgenteControlComunidadAutonomaCollection: RegAgenteControlComunidadAutonomaViewModel[];
}

export class RegAgenteControlComunidadAutonomaViewModel {
    public Id: number;

    public IdAgenteControl: number;

    public IdCa: number | null;

    public Descripcion = '';

    public ActivacionInicial: boolean;

    public FechaActivacionInicial: Date | null;

    public Baja = false;

    public FechaBaja: Date | null;

    public TwRegAgenteControlCaFormaCollection: RegAgenteControlCaFormaViewModel[];
}

export class RegAgenteControlCaFormaViewModel {
    public Id: number;

    public IdAcCa: number;

    public IdForma: number;

    public IdFormaDescripcion = '';
}
